// extracted by mini-css-extract-plugin
module.exports = {"form":"sendToSAGE_form__3mZzk","form__checkbox":"sendToSAGE_form__checkbox__liD1W"};